import React, { useEffect, useState } from 'react'
import { PosSectionMain } from '../../../components-pos'
import { onlposGetPayRecords } from '../../../lib/api-onlpos'
import {
  getPriceStr,
  getTimestampFromNow,
  isJson,
} from '../../../../../lib/utils'
import { CustomTable2 } from '../../../../../components/Tables2'
import { debug } from '../../../../../settings'
import { CalendarDropdown } from '../../../../../components/CalendarInput2'

const tableHeader = [
  // { name: 'orderId', displayName: '아이디', selectKey: true },
  { name: 'payMethod', displayName: '결제방법', sorting: true },
  { name: 'pgName', displayName: 'PG명', sorting: true },
  { name: 'cardName', displayName: '카드명', sorting: true },
  { name: 'orderAmt2', displayName: '금액' },
  { name: 'orderName', displayName: '결제내역' },
  // { name: 'payTime', displayName: '결제일시' },
  { name: 'created', displayName: '결제일' },
]

export function ByHour(props) {
  const { shopInfo } = props

  const [records, setRecords] = useState([])

  const today = new Date()
  const _startDate = new Date(
    getTimestampFromNow({ now: new Date(), days: -1 }),
  )
  const [startDate, setStartDate] = useState(_startDate)
  const [endDate, setEndDate] = useState(today)

  useEffect(() => {
    async function start() {
      try {
        // const start_time = new Date(startDate).getTime()
        // const end_time = new Date(endDate).getTime()
        // let res = await onlposGetPayRecords({ shopInfo, start_time, end_time })
        // if (res.err) throw Error(res.err.message)
        // const payRecordes = parsePayData(res.result.Items)
        // const arr = payRecordes.map((p) => {
        //   return {
        //     ...p,
        //     payMethod: p.payData.payMethod,
        //     pgName: p.pgName === 'cash' ? '-' : p.pgName,
        //     cardName: p.payData?.cardName || '-',
        //     created: p.created,
        //     orderAmt2: getPriceStr(p.orderAmt),
        //   }
        // })
        // setRecords(arr)
      } catch (e) {
        alert(e.message)
      }
    }
    start()
  }, [startDate, endDate])

  const styles = {
    caledarWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      // justifyContent: "space-around"
    },
  }

  return (
    <PosSectionMain>
      <div style={styles.caledarWrap}>
        <CalendarDropdown
          label="날짜"
          variant="dark"
          date={startDate}
          setDate={setStartDate}
        />
      </div>

      <CustomTable2
        variant="info"
        tableHeader={tableHeader}
        rowItems={records}
        setRowItems={setRecords}
        // onClickItem={onClickGrpEdit}
      />
    </PosSectionMain>
  )
}

function Summary(props) {
  return <div>결제 형태별 정리</div>
}

function parsePayData(payRecordList) {
  const parsed = payRecordList.map((r) => {
    return {
      ...r,
      orderData: isJson(r.orderData) ? JSON.parse(r.orderData) : null,
      payData: isJson(r.payData) ? JSON.parse(r.payData) : null,
    }
  })
  return parsed
}
